<template>
  <div class="row">
    <div
      class="col-md-12 col-lg-12 aos-init aos-animate content d-flex flex-column mt-1 mb-5 mx-auto"
      data-aos="fade-up"
      data-aos-delay="100"
    >
      <div class="card card-custom gutter-b">
        <div class="card-header flex-wrap border-0 pt-6 pb-0">
          <div class="card-title">
            <h3 class="card-label">
              Mensaje Global
              <span class="d-block text-muted pt-2 font-size-sm"
                >Mensaje para mostrar en toda la plataforma</span
              >
            </h3>
          </div>
        </div>
        <div class="card-body">
          <div class="form-group">
            <label>Mensaje</label>
            <input
              type="text"
              class="form-control"
              v-model="configuracion.valor"
            />
          </div>

          <div class="form-group mt-5">
            <label>Mostrar Mensaje</label>
            <input type="checkbox" v-model="configuracion.activo" class="" />
          </div>
          <button class="btn btn-primary align-self-start mt-5" @click="actualizarMensaje">
            Actualizar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapState } from "vuex";
import {
  GET_CONFIGURACION,
  UPDATE_CONFIGURACION,
} from "@/core/services/store/configuracion.module";
export default {
  name: "mensaje",
  components: {
    /*Money,*/
  },
  data() {
    return {
      configuracion: { codigo: "", valor: "", activo: false },
    };
  },
  mounted() {
    this.obtenerConfiguracion();
  },

  methods: {
    obtenerConfiguracion() {
      this.$store
        .dispatch(GET_CONFIGURACION, "MENSAJEGLOBAL")
        .then((response) => {
          (this.configuracion = response), (this.loading = false);
        });
    },
    actualizarMensaje() {
      this.$store
        .dispatch(UPDATE_CONFIGURACION, this.configuracion)
        
        .then(() => {
          this.$bvToast.toast(
            `Mensaje actualizado.`,
            {
              title: "Actualizado",
              autoHideDelay: 5000,
              variant: "success",
              toaster: "b-toaster-top-right",
              appendToast: true,
            }
          );
          location.reload()
        });
        
    },
  },
  computed: {
    ...mapState({
      configuracions: (state) => state.configuracion.configuracions,
      errors: (state) => state.errors,
      client: (state) => state.auth.configuracion,
    }),
  },
};
</script>
<style>
.container {
  max-width: 1185px !important;
}
.b-form-datepicker {
  min-width: 130px;
}
.b-form-datepicker label {
  padding-bottom: 3px !important;
  padding-top: 6px;
  text-transform: none;
  white-space: nowrap !important;
  font-size: 1rem !important;
}
.b-form-datepicker .btn:not(:disabled):not(.disabled) {
  cursor: pointer;
  padding: 10px 5px;
}
.d-content-full {
  width: 100%;
}

.v-data-table .btn,
.card-toolbar .btn {
  border-radius: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
  padding: 7px 20px 6px 20px;
  text-transform: uppercase;
}

.card.card-custom > .card-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  min-height: 70px;
  padding-top: 0;
  padding-bottom: 0;
  background-color: transparent;
}

.card-header:first-child {
  border-radius: calc(0.42rem - 1px) calc(0.42rem - 1px) 0 0;
}
.pt-6,
.py-6 {
  padding-top: 1.5rem !important;
}
.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}
.flex-wrap {
  -ms-flex-wrap: wrap !important;
  flex-wrap: wrap !important;
}
.border-0 {
  border: 0 !important;
}
.card-header {
  padding: 2rem 2.25rem;
  margin-bottom: 0;
  background-color: #ffffff;
  border-bottom: 1px solid #ebedf3;
}
.btn.btn-primary {
  color: #ffffff;
  background-color: #3699ff;
  border-color: #3699ff;
}
.btn:not(.btn-text) {
  cursor: pointer;
}
.btn {
  outline: none !important;
  vertical-align: middle;
  -webkit-transition: color 0.15s ease, background-color 0.15s ease,
    border-color 0.15s ease, -webkit-box-shadow 0.15s ease;
  transition: color 0.15s ease, background-color 0.15s ease,
    border-color 0.15s ease, -webkit-box-shadow 0.15s ease;
  transition: color 0.15s ease, background-color 0.15s ease,
    border-color 0.15s ease, box-shadow 0.15s ease;
  transition: color 0.15s ease, background-color 0.15s ease,
    border-color 0.15s ease, box-shadow 0.15s ease,
    -webkit-box-shadow 0.15s ease;
}
.font-weight-bolder {
  font-weight: 600 !important;
}
.btn-primary {
  color: #ffffff;
  background-color: #3699ff;
  border-color: #3699ff;
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>
